import { render, staticRenderFns } from "./DisbursementInputTypeCheckbox.vue?vue&type=template&id=10025ba0&"
import script from "./DisbursementInputTypeCheckbox.vue?vue&type=script&lang=js&"
export * from "./DisbursementInputTypeCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QCheckbox} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QField,QCheckbox})
